import { Pipe, PipeTransform } from '@angular/core';

/**
 * Best-effort US-style display for prototype API phone strings (digits-only and E.164-ish).
 */
@Pipe({
  name: 'formatPrototypePhone',
  standalone: true,
})
export class FormatPrototypePhonePipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (value == null || !String(value).trim()) {
      return '';
    }
    const digits = String(value).replace(/\D/g, '');
    if (digits.length === 10) {
      return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
    }
    if (digits.length === 11 && digits.startsWith('1')) {
      return `+1 (${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7)}`;
    }
    return String(value).trim();
  }
}
